import React, { useEffect, useState } from 'react';

import { ArrowDown } from '../../icons';
import {
  StyledArrow,
  StyledIcon,
  StyledLabel,
  StyledSelect,
  StyledWrapper,
} from './DropDown.styles';
import { IDropDownProps } from './DropDown.types';

const DropDown = ({
  children,
  icon,
  id,
  label,
  name,
  user = 'neutral',
  value = '',
  options,
  onChange,
  onFocus,
  onBlur,
}: IDropDownProps): JSX.Element => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>('');

  const handleOnFocus = (e: React.FocusEvent<HTMLSelectElement>) => {
    setIsActive(true);
    onFocus && onFocus(e);
  };

  const handleOnBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    isEmpty && setIsActive(false);
    onBlur && onBlur(e);
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setInputValue(e.target.value);
    onChange && onChange(e);
  };

  useEffect(() => {
    setIsEmpty(inputValue.length <= 0);
  }, [inputValue]);

  return (
    <StyledWrapper isActive={isActive} isEmpty={isEmpty}>
      <StyledArrow>
        <ArrowDown />
      </StyledArrow>
      {icon && <StyledIcon>{icon}</StyledIcon>}
      <StyledSelect
        id={id}
        name={name}
        user={user}
        value={value}
        onChange={handleOnChange}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      >
        {label && <option />}
        {options.map(({ text, value }, index) => (
          <option key={index} value={value}>
            {text}
          </option>
        ))}
      </StyledSelect>
      {label && <StyledLabel htmlFor={id}>{label}</StyledLabel>}
      {children}
    </StyledWrapper>
  );
};

export default DropDown;
